import { render, staticRenderFns } from "./marketing-layout.vue?vue&type=template&id=031eec3a"
import script from "./marketing-layout.vue?vue&type=script&lang=ts"
export * from "./marketing-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports